import React from "react";
import { QRCodeSVG } from "qrcode.react";
const Qrcode = (props) => {
  return (
    <div>
      <div
        style={{ width: 290, height: 100,border:"1px dotted #EBECEC" }}
        className="d-flex p-1 "
      >
        <QRCodeSVG size="90" value={props.aircon_id} />
        <div
          className="flex-fill"
          style={{ fontSize: 12, paddingLeft: 5, background: "#F4F5F5" }}
        >
          <div className="fw-bold text-primary"> Letscool</div>
          <div>#{props.aircon_id.slice(props.aircon_id.indexOf('=') + 1)}</div>
          <div style={{fontSize:8,marginTop:38}}><a href="">www.letscoolaircon.com.sg</a></div>
        </div>
      </div>
    </div>
  );
};

export default Qrcode;
